<template>
  <div>
    <v-container fluid>
      <v-row align="center">
        <v-col class="d-flex" xs="12">
          <v-text-field
            v-model="searchText"
            label="Search"
            :persistent-hint="true"
            hint="Medicine name"
            @input="updateFilteredMedicines"
          />
        </v-col>
      </v-row>
      <v-layout wrap class="mt-4">
        <table>
          <thead>
            <tr>
              <th>Generic name</th>
              <th>Trade name</th>
              <th>Dosage</th>
              <th>Sell unit</th>
              <th>Unit</th>
              <th>Dosage/day</th>
              <th>How to take</th>
              <th>When to take</th>
              <th>Price</th>
              <th>Detail</th>
              <th>Active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(medicine, index) in filteredMedicines" :key="index">
              <td>{{ medicine.genericName }}</td>
              <td>{{ medicine.tradeName }}</td>
              <td>{{ medicine.dosage }}</td>
              <td>{{ medicine.sellUnitTh }}</td>
              <td>{{ medicine.unitTh }}</td>
              <td>{{ medicine.dosageTh ? medicine.dosageTh : '-' }}</td>
              <td>{{ medicine.howToTakeTh ? medicine.howToTakeTh : '-' }}</td>
              <td>{{ medicine.timeTh ? medicine.timeTh : '-' }}</td>
              <td>{{ formattedNumber(medicine.price) }} THB</td>
              <td>{{ medicine.detailTh ? medicine.detailTh : '-' }}</td>
              <td>
                <div class="d-flex flex-row">
                  <v-switch
                    v-model="medicine.active"
                    @change="toggleMedicineActive(medicine._id, medicine.active)"
                    dense
                  ></v-switch>
                </div>
              </td>
              <td>
                <AddOrEditMedicine :isAdd="false" :medicine="medicine" @success="fetchMedicines" />
              </td>
            </tr>
          </tbody>
        </table>
        <v-flex xs12>
          <AddOrEditMedicine @success="fetchMedicines" :isAdd="true" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;

  td,
  th {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: start;
  }
}

.icon {
  cursor: pointer;
}
</style>

<script>
import axios from 'axios';
import { Vue } from 'vue-property-decorator';
import numberUtil from '../../../utils/number';
import AddOrEditMedicine from './components/AddOrEditMedicine.vue';

export default Vue.extend({
  components: {
    AddOrEditMedicine,
  },
  data() {
    return {
      medicines: [],
      filteredMedicines: [],
      searchText: '',
    };
  },
  mounted() {
    this.fetchMedicines();
  },
  methods: {
    formattedNumber: numberUtil.commaWithDecimal,
    async fetchMedicines() {
      await axios.get(`${process.env.VUE_APP_EPRES_ENDPOINT}admin/medicines`).then((response) => {
        this.medicines = response.data.data.map((medicine) => {
          return {
            ...medicine,
            price: Number(medicine.price),
          };
        });

        this.updateFilteredMedicines();
      });
    },
    async toggleMedicineActive(id, active) {
      const data = {
        medicine_id: id,
        active,
      };
      await axios
        .post(`${process.env.VUE_APP_EPRES_ENDPOINT}admin/medicines`, data)
        .then(() => {
          this.fetchMedicines();
        })
        .catch((error) => {
          console.error('Error updating medicine active status:', error);
        });
    },
    updateFilteredMedicines() {
      this.filteredMedicines = this.medicines.filter((medicine) => {
        return (
          medicine.genericName.toLowerCase().includes(this.searchText.toLowerCase()) ||
          medicine.tradeName.toLowerCase().includes(this.searchText.toLowerCase()) ||
          medicine.dosage.toLowerCase().includes(this.searchText.toLowerCase()) ||
          medicine.detailTh.toLowerCase().includes(this.searchText.toLowerCase()) ||
          medicine.dosageTh.toLowerCase().includes(this.searchText.toLowerCase()) ||
          medicine.howToTakeTh.toLowerCase().includes(this.searchText.toLowerCase())
        );
      });
    },
  },
});
</script>
